<template>
    <!-- 微信支付失败 -->
    <div>
        <!-- v-show="$route.meta.showFather" -->
        <div class="pad-16 mb-16 box-shadow">
            <div class="is-flex mb-24">
                <div class="left-icon"></div>
                <p class="left-p">扫码支付</p>
            </div>
            <div class="is-flex jus-bet te-c">
                <div></div>
                <div>
                  <img src="../../../assets/fail.png" alt="" class="wxzf mb-16">
                  <p class="mb-16 net">请检查您的网络</p>
                  <div class="is-flex zhifu" @click="goBack">
                      <p>返回</p>
                      <p>重新支付</p>
                  </div>  
                </div>
                <div></div>
                
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {
                infoShow: true,
                taus:''
            }
        },
        created() {
            
        },
        mounted() {
        },
        methods: {
			goBack(){
				this.$router.go(-2);
			},
            wxpay(){
                this.taus = 1;
                if(this.taus = 1){
                    this.$router.push('/activity/paymentSuccess')
                    // console.log(this.$route.matched,'----this.$route.matched')
                    // this.$route.matched[4].meta.title = '11111'
                }else{
                    this.$router.push('/activity/paymentFail')
                }
            }
        }
    }
</script>


<style scoped>
    .pad-16 {
        padding:32px 16px;

    }
    .box-shadow {
        box-shadow: 0px 2px 8px 0px rgba(195, 219, 255, 0.25);
        border-radius: 8px 8px 8px 8px;
    }

    .is-flex {
        display: flex;
        align-items: center;
    }

    .jus-bet {
        justify-content: space-between;
    }


    .mb-24 {
        margin-bottom: 24px;
    }

    .mb-16 {
        margin-bottom: 16px;
    }

    .left-icon {
        width: 6px;
        height: 20px;
        background: #3377FF;
        border-radius: 18px;
    }

    .left-p {
        font-size: 20px;
        color: #222222;
        font-weight: normal;
        padding-left: 10px;
    }

    .wxzf {
        width: 62px;height: 84px;
    }
    .te-c{
        text-align: center;
    }
    .net{
        color: #222222;
        font-size: 14px;
    }
    .zhifu p{
        font-size: 16px;
        border-radius: 4px 4px 4px 4px;
    }
    .zhifu p:first-child{
        background-color: #F0F5FF;
        color: #3377FF;
        margin-right: 16px;
        padding: 12px 74px;
    }
    .zhifu p:last-child{
        background-color: #3377FF;
        color: #FFFFFF;
        padding: 12px 58px;
    }
</style>
